import React, {useEffect, useState} from 'react';

import { useModalUpdate, useVideoModalUpdate } from "../../components/context/ModalContext";
import { useDataUpdate } from "../../components/context/DataContext";

import Button from '../../components/Buttons/Button';
import cirleImg from "../../assets/images/center-circle.png";
import cirleImgTab from "../../assets/images/center-circle-tab.png";

import { gaMenuButtonClick } from '../../utils/gatags';

import './Content.css';
import Footer from '../Footer/Footer';

const Content = () => {

    const setDataState = useDataUpdate();
    const [data, setData] = useState(null);
    const audioModalSet = useModalUpdate(true);

    const setModalContent = (_sec) => {
        audioModalSet(true);
        gaCapture(_sec);
    }

    const gaCapture = (_idx) => {
        const modalEl = document.getElementsByClassName("btn" + _idx);
        gaMenuButtonClick(modalEl[0].classList[1], modalEl[0].innerText.replace(/(\r\r|\n\n)/gm, " - "));
    }

    useEffect(() => {
        fetch('./content.json'
    ,{
      headers : { 
        'Content-Type': 'application/json',
        'Accept': 'application/json'
       }
    }
    )
    .then(function(response){
        return response.json();
    })
    .then(function(dataJson) {
        setData(dataJson);
        setDataState(dataJson);
    });


    }, [setDataState]) 


    if (!data) {
        return (
            <div className="loading-elem">
                <p>Loading data...</p>;
            </div>
        )
    }

    return (
        <div className="App">
            <div id="component-574086">
                <div className="content">
                    <div className="mobile-header">
                        <h1>Lessons from other therapy areas</h1>
                    </div>
                    <div className="tab">
                        <div className="tab-circle">
                            <img src={cirleImgTab} alt="Center circle" />
                            <div className='center-text'>Lessons<span className="adaptive-break"><br /></span>from other<span className="adaptive-break"><br /></span> therapy areas</div>
                        </div>
                        <div className="container">
                            <div className="child">
                                <Button id="0" clickitem={setModalContent} />
                                <Button id="1" clickitem={setModalContent} />
                            </div>
                            <div className="child circle-wrap">
                                <div className="circle">
                                    <img src={cirleImg} alt="Center circle" />
                                    <div className='center-text'>Lessons<span className="adaptive-break"><br /></span>from other<span className="adaptive-break"><br /></span> therapy areas</div>
                                </div>
                            </div>
                            <div className="child">
                                <Button id="2" clickitem={setModalContent} />
                                <Button id="3" clickitem={setModalContent} />
                            </div>
                            <div className="span-columns">
                                <Button id="4" clickitem={setModalContent} />
                            </div>
                        </div>
                        
                    </div>
                    <Footer />
                </div>
            </div>
        </div>
        );
    };
    
    export default Content;